import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {TitleService} from '../services/title.service';
import {TranslateService} from '@ngx-translate/core';
import {ContentHeaderService} from '../services/content-header.service';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-void',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export abstract class AuthenticatedBaseComponent implements AfterViewInit, OnDestroy {
  @ViewChild('contentHeaderTemplate') public contentHeaderTemplate!: TemplateRef<string>

  protected onDestroy$: Subject<void> = new Subject<void>();

  // public save(): void {}
  //
  // @HostListener('window:keydown.meta.s', ['$event'])
  // public saveOnKeyPress(event: KeyboardEvent) {
  //   if (this.save) {
  //     event.preventDefault()
  //     this.save()
  //   }
  // }

  public constructor(
    protected readonly cdr: ChangeDetectorRef,
    protected readonly translate: TranslateService,
    protected readonly contentHeaderService: ContentHeaderService,
    protected readonly titleService: TitleService,
  ) {
    this.titleService.title$.subscribe(() => this.cdr.markForCheck());
  }

  public ngAfterViewInit() {
    this.contentHeaderService.setContentHeader(this.contentHeaderTemplate);
  }

  public ngOnDestroy() {
    this.onDestroy$.next();
  }
}
